import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import FlooringContractor from "@/pages/FlooringContractor";
import CityPage from "@/pages/CityPage";
import BlogLvpVsLaminateVsTile from "@/pages/BlogLvpVsLaminateVsTile";
import ServicesPage from "@/pages/Services";
import ChatWidget from "@/components/site/ChatWidget";
import VisualizerLauncher from "@/components/site/VisualizerLauncher";
import VisualizerModal from "@/components/site/VisualizerModal";
import {
  OFALLON_CONFIG,
  WENTZVILLE_CONFIG,
  CHESTERFIELD_CONFIG,
  KIRKWOOD_CONFIG,
  BALLWIN_CONFIG,
  STPETERS_CONFIG,
  STCHARLES_CONFIG,
  CLAYTON_CONFIG,
} from "@/lib/cityConfigs";

function App() {
  const [visualizerOpen, setVisualizerOpen] = useState(false);

  useEffect(() => {
    const openHandler = () => setVisualizerOpen(true);
    window.addEventListener("open-visualizer", openHandler);
    return () => window.removeEventListener("open-visualizer", openHandler);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route
            path="/flooring-contractor-st-louis"
            element={<FlooringContractor />}
          />
          <Route
            path="/flooring-installation-ofallon-mo"
            element={<CityPage config={OFALLON_CONFIG} />}
          />
          <Route
            path="/flooring-installation-wentzville-mo"
            element={<CityPage config={WENTZVILLE_CONFIG} />}
          />
          <Route
            path="/flooring-installation-chesterfield-mo"
            element={<CityPage config={CHESTERFIELD_CONFIG} />}
          />
          <Route
            path="/flooring-installation-kirkwood-mo"
            element={<CityPage config={KIRKWOOD_CONFIG} />}
          />
          <Route
            path="/flooring-installation-ballwin-mo"
            element={<CityPage config={BALLWIN_CONFIG} />}
          />
          <Route
            path="/flooring-installation-st-peters-mo"
            element={<CityPage config={STPETERS_CONFIG} />}
          />
          <Route
            path="/flooring-installation-st-charles-mo"
            element={<CityPage config={STCHARLES_CONFIG} />}
          />
          <Route
            path="/flooring-installation-clayton-mo"
            element={<CityPage config={CLAYTON_CONFIG} />}
          />
          <Route
            path="/blog/lvp-vs-laminate-vs-tile-st-louis"
            element={<BlogLvpVsLaminateVsTile />}
          />
        </Routes>
      </BrowserRouter>
      <VisualizerLauncher />
      <VisualizerModal
        open={visualizerOpen}
        onClose={() => setVisualizerOpen(false)}
      />
      <ChatWidget />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
